import { c as _c } from "react/compiler-runtime";
import { DigitalProductId } from 'modules/digital-product/types/digital-product-interface';
import { OfferId } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/offer-interface';
import { useStore } from 'modules/stores/store/hooks/use-store';
import { StoreId } from 'modules/stores/types/stores-interface';
import { useItemProductActions } from '../../../hooks/use-item-product-actions';
import { ProductECourseItemEditType, ProductECourseItemViewType } from '../../../types/product-interface';
import { getItemUpdateData } from '../../../utils/get-item-update-data';
export const useSaveCourseItem = t0 => {
  const $ = _c(14);
  const {
    storeId
  } = t0;
  const {
    mutate: mutateStore
  } = useStore(storeId);
  const {
    createECourse,
    updateECourse
  } = useItemProductActions();
  let t1;
  if ($[0] !== mutateStore || $[1] !== updateECourse) {
    t1 = async (item, digitalProductId, offerId) => {
      const mutateProductItemData = async responseData => {
        await mutateStore(data => data && {
          ...data,
          items: data.items.map(i => i.itemId === responseData.itemId ? responseData : i)
        }, false);
      };
      const responseData_0 = await updateECourse(item.id, getItemUpdateData({
        item,
        digitalProductId,
        offerId
      }));
      await mutateProductItemData(responseData_0);
    };
    $[0] = mutateStore;
    $[1] = updateECourse;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const updateItem = t1;
  let t2;
  if ($[3] !== createECourse || $[4] !== mutateStore || $[5] !== storeId) {
    t2 = async (item_0, digitalProductId_0, offerId_0) => {
      const mutateProductItemData_0 = async responseData_1 => await mutateStore(data_0 => data_0 && {
        ...data_0,
        items: [...data_0.items, responseData_1]
      }, false);
      const responseData_2 = await createECourse(storeId, getItemUpdateData({
        item: item_0,
        digitalProductId: digitalProductId_0,
        offerId: offerId_0
      }));
      await mutateProductItemData_0(responseData_2);
    };
    $[3] = createECourse;
    $[4] = mutateStore;
    $[5] = storeId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const createItem = t2;
  let t3;
  if ($[7] !== createItem || $[8] !== updateItem) {
    t3 = async (item_1, digitalProductId_1, offerId_1) => {
      if (item_1.id) {
        await updateItem({
          ...item_1,
          id: item_1.id
        }, digitalProductId_1, offerId_1);
      } else {
        await createItem(item_1, digitalProductId_1, offerId_1);
      }
    };
    $[7] = createItem;
    $[8] = updateItem;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const saveItem = t3;
  let t4;
  if ($[10] !== createItem || $[11] !== saveItem || $[12] !== updateItem) {
    t4 = {
      updateItem,
      createItem,
      saveItem
    };
    $[10] = createItem;
    $[11] = saveItem;
    $[12] = updateItem;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};